import React, { Fragment, useMemo } from "react"
import { withRouter } from "react-router"
import { useSelector } from "react-redux"
import DealMemoCard from "../../../../../components/Billing/Admin/DealMemoCard/index"
import { Card, Box } from "@material-ui/core"
import SimpleExpenseTotal from "../../../../../components/Billing/Common/SimpleExpenseTotal/index"
import NoData from "../../../../../components/Billing/Admin/NoData/index"

const DealMemoPage = props => {
  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)

  let id = props.match.params.shoot_id

  //combine expenses to now the total of expenses
  const combinedExpensesArray = useMemo(
    () => {
      let newArray = []
      usersRolesArray.map(x => {
        x.expenses.map(y => {
          newArray.push(y)
        })
      })
      return newArray
    },
    [usersRolesArray]
  )

  return (
    <Box>
      {usersRolesArray.length === 0 ? (
        <NoData />
      ) : (
        usersRolesArray &&
        usersRolesArray.map(position => {
          return (
            <Fragment key={position.user_id}>
              <DealMemoCard position={position} shootId={id} />
            </Fragment>
          )
        })
      )}
      {usersRolesArray.length > 0 && (
        <Card
          style={{
            paddingLeft: "20px",
            paddingBottom: "20px",
            paddingTop: "20px",
            marginBottom: "16px",
            borderRadius: "10px",
          }}
        >
          <Box style={{ justifyContent: "flex-end", marginRight: "30px" }}>
            <SimpleExpenseTotal
              data={[{ expenses: [...combinedExpensesArray] }]}
            />
          </Box>
        </Card>
      )}
    </Box>
  )
}
export default withRouter(DealMemoPage)
